import React from 'react';
import ReactDOM from 'react-dom/client';

import OpeningHours from './OpeningHours';

const root = ReactDOM.createRoot(document.getElementById('opening_hours'));

root.render(
  <React.StrictMode>
    <OpeningHours />
  </React.StrictMode>
);
